import React, { ReactElement } from 'react';
import cn from 'classnames';
import IconProps from '../IconProps';
import '../design-catalogue-icons.scss';

export default function IconArrow({ className, ariaHidden = false }: IconProps): ReactElement {
    return <div className={cn('icon-arrow', className)} aria-hidden={ariaHidden} />;
}
